import { base as o } from "./base.js";
import { dark as r } from "./dark.js";
const e = {
  light: o,
  dark: r
};
export {
  e as themes
};
//# sourceMappingURL=index.js.map
